define(["exports", "hyperhtml", "../core/utils", "../core/pubsubhub", "../core/render-biblio", "../core/inlines"], function (_exports, _hyperhtml, _utils, _pubsubhub, _renderBiblio, _inlines) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n          <p>\n            The key word", " ", " in this document\n            ", " to be interpreted as described in\n            <a href=\"https://tools.ietf.org/html/bcp14\">BCP 14</a>\n            ", "\n            ", " when, and only when, they appear\n            in all capitals, as shown here.\n          </p>\n        "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n    <h2>Conformance</h2>\n    <p>\n      As well as sections marked as non-normative, all authoring guidelines,\n      diagrams, examples, and notes in this specification are non-normative.\n      Everything else in this specification is normative.\n    </p>\n    ", "\n  "]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "w3c/conformance";
  /**
   * @param {Element} conformance
   * @param {*} conf
   */

  _exports.name = name;

  function processConformance(conformance, conf) {
    const terms = [...Object.keys(_inlines.rfc2119Usage)]; // Add RFC2119 to blibliography

    if (terms.length) {
      conf.normativeReferences.add("RFC2119");
      conf.normativeReferences.add("RFC8174");
    } // Put in the 2119 clause and reference


    const keywords = (0, _utils.joinAnd)(terms.sort(), item => "<em class=\"rfc2119\">".concat(item, "</em>"));
    const plural = terms.length > 1;
    const content = (0, _hyperhtml.default)(_templateObject(), terms.length ? (0, _hyperhtml.default)(_templateObject2(), plural ? "s" : "", [keywords], plural ? "are" : "is", (0, _renderBiblio.renderInlineCitation)("RFC2119"), (0, _renderBiblio.renderInlineCitation)("RFC8174")) : null);
    conformance.prepend(...content.childNodes);
  }

  function run(conf) {
    const conformance = document.querySelector("section#conformance");

    if (conformance) {
      processConformance(conformance, conf);
    } // Added message for legacy compat with Aria specs
    // See https://github.com/w3c/respec/issues/793


    (0, _pubsubhub.pub)("end", name);
  }
});
//# sourceMappingURL=conformance.js.map